import { useContext, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomDateTimePicker from "./../../../utils/CustomDateTimePicker/CustomDateTimePicker";
import { ConfigModal } from "../ConfigAdmin/ConfigAdmin";
import { groupChargeAdminContext } from "../../../context/Admin/GroupChargeAdminContext/GroupChargeAdminContext";

const GroupChargeAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    employers,
    balance,
    setBalance,
    employer,
    setEmployer,
    smsType,
    setSmsType,
    setFrom,
    setTo,
    smsText,
    setSmsText,
    handleGetEmployerList,
    handleCreateGroupCharge,
  } = useContext(groupChargeAdminContext);

  useEffect(() => {
    handleGetEmployerList();
  }, []);

  return (
    <>
      <SiteTitle title="شارژ گروهی" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "شارژ گروهی", type: "a" },
        ]}
        title="شارژ گروهی"
      />
      <CardLayout className="mt-4 py-5">
        <div className="mb-2">
          <ConfigModal
            title="تنظیمات شارژ گروهی"
            configTypes={[
              "WALLET_CASHBACK_USAGE_LIMIT",
              "CASHBACK_CONSTANT_AMOUNT",
              "CASHBACK_PERCENTAGE",
              "NEW_USER_WALLET_CHARGE",
            ]}
          />
        </div>
        <Alert className="text-justify">
          برای شارژ گروهی شما میتوانید بر اساس سازمان، بازه زمانی و یا هردو در
          حالت های مختلف از جمله مناسبتی و یا سازمانی اقدام نمایید
        </Alert>
        <div className="row mt-5">
          <div className="col-12 col-sm-6 col-lg-4 mb-4">
            <label htmlFor="smsType">نوع شارژ</label>
            <select
              id="smsType"
              className="form-control"
              value={smsType}
              onChange={(e) => setSmsType(e.target.value)}
            >
              <option value="" selected hidden disabled></option>
              <option value="organization">سازمانی</option>
              <option value="occasion">مناسبتی</option>
            </select>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-4">
            <label htmlFor="balance">مبلغ</label>
            <input
              type="number"
              id="balance"
              name="balance"
              className="form-control"
              min={0}
              value={balance}
              onChange={(e) => setBalance(e.target.value)}
            />
          </div>
        </div>
        <div className="row mt-5">
          {smsType === "organization" && (
            <div className="col-12 col-sm-6 col-lg-4 mb-4">
              <label htmlFor="employer">سازمان</label>
              <select
                id="employer"
                className="form-control"
                value={employer}
                onChange={(e) => setEmployer(e.target.value)}
              >
                <option value="" selected hidden disabled></option>
                {employers?.map((_item) => (
                  <option
                    key={_item.id}
                    value={_item.id}
                    selected={employer === _item.id}
                  >
                    {_item.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          {smsType === "occasion" && (
            <>
              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <label htmlFor="expiration_date">از تاریخ</label>
                <CustomDateTimePicker // or use "react-hichestan-datetimepicker"
                  type="single"
                  onChange={(e) => setFrom(e)}
                />
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <label htmlFor="expiration_date">تا تاریخ</label>
                <CustomDateTimePicker // or use "react-hichestan-datetimepicker"
                  type="single"
                  onChange={(e) => setTo(e)}
                />
              </div>
            </>
          )}
        </div>
        <div className="mt-5">
          <Alert className="text-justify alert-info">
            در صورت وارد کردن متن دلخواه متن وارد شده برای کاربر پیامک میشود در
            غیر این صورت متن پیشفرض که در قسمت قالب های پیامکی تعریف شده استفاده می شود!
          </Alert>
          <label htmlFor="expiration_date">متن پیامک دلخواه</label>
          <textarea
            value={smsText}
            onChange={(e) => setSmsText(e.target.value)}
            className="form-control mb-4"
            rows={5}
          />
        </div>
        {permission.wallet_group_charge && (
          <div>
            <button
              className="btn btn-success"
              onClick={() => handleCreateGroupCharge(null, "inc")}
            >
              <i className="fas fa-check mr-2" /> افزایش
            </button>
            <button
              className="btn btn-danger ml-3"
              onClick={() => handleCreateGroupCharge(null, "dec")}
            >
              <i className="fas fa-times mr-2" /> کاهش
            </button>
          </div>
        )}
      </CardLayout>
    </>
  );
};

export default GroupChargeAdmin;
